import { useState } from 'react';
import {
    GetUserPropertyRelationshipQuery,
    GetUserPropertyRelationshipDocument
} from './GetUserPropertyRelationship.generated';
import { fetchGraphql } from '@zoopla/fetch-graphql';
import { isMyHomeRelationship } from '@zoopla/map-relationship';

const IS_HOMEOWNER_KEY = 'hm-notifications-is-homeowner';

const determineIsHomeOwner = async () => {
    try {
        const { data } = await fetchGraphql<GetUserPropertyRelationshipQuery>(
            GetUserPropertyRelationshipDocument
        );

        return isMyHomeRelationship(
            data?.user?.trackedProperties?.items[0].relationship
        );
    } catch {
        return false;
    }
};

/**
 * Checks whether a user has tracked any properties with a homeowner or landlord relationship.
 *
 * Result cached for session duration.
 */
export const useIsHomeOwner = (skip: boolean) => {
    const [isHomeOwner, setIsHomeOwner] = useState(false);

    if (skip) {
        return false;
    }

    const cachedValue = sessionStorage.getItem(IS_HOMEOWNER_KEY);
    if (cachedValue) {
        return JSON.parse(cachedValue);
    }

    (async () => {
        const trackedPropertyAsHomeOwner = await determineIsHomeOwner();
        sessionStorage.setItem(
            IS_HOMEOWNER_KEY,
            JSON.stringify(trackedPropertyAsHomeOwner)
        );
        setIsHomeOwner(trackedPropertyAsHomeOwner);
    })();

    return isHomeOwner;
};
